import { LoanApplicationLocalStorageKeys } from '../../../utils/constants/LocalStorageKeys.enum'
import {
  resetLoan,
  setCompanyVerificationMethod,
  setDecisionMaker,
  setDirector,
  setEntityData,
  setFundDetails,
  setGuarantor,
  setLoanApplication,
  setLoanEligibility,
  setLoanStep,
  setLoanSubStep,
  setPartnerDetails,
  setPersonData,
  setShareholders,
  setSingPassInfo,
} from './redux/actions'
import { useDispatch } from 'react-redux'

const NoDataProvided = () => {
  const dispatch = useDispatch()

  const startFreshApplication = () => {
    window.open('/agent-application', '_blank')
    localStorage.removeItem('loanApplicationId')
    localStorage.removeItem('companyUEN')
    localStorage.removeItem('companyVerificationMethod')
    localStorage.removeItem('singpass')
    localStorage.removeItem('errorLogged')
    localStorage.removeItem('perfiosId')
    localStorage.removeItem('coApplicationId')
    localStorage.removeItem('accountDetails')
    localStorage.removeItem('uploadedFiles')
    localStorage.removeItem('loanType')
    localStorage.removeItem('partnerApplicationType')
    localStorage.removeItem(LoanApplicationLocalStorageKeys.LOAN_APPLICATION_SUBMISSION_METHOD)
    // Reset all Redux state to initial values
    dispatch(resetLoan())
    dispatch(setLoanApplication(null))
    dispatch(setLoanEligibility(null))
    dispatch(setEntityData(null))
    dispatch(setPersonData(null))
    dispatch(setShareholders([]))
    dispatch(setGuarantor([]))
    dispatch(setDirector([]))
    dispatch(setDecisionMaker(null))
    dispatch(setSingPassInfo(null))
    dispatch(setPartnerDetails(null))
    dispatch(setFundDetails(null))
    dispatch(setCompanyVerificationMethod(0))
    dispatch(setLoanStep(1))
    dispatch(setLoanSubStep(0))
  }

  return (
    <div className='d-flex justify-content-center align-items-center flex-column'>
      <img src='/media/logos/nodataicon.svg' alt='nodataicon' />
      <p className='my-6'>There are no ongoing loan applications</p>
      <button
        className='button button-primary start-app-btn'
        onClick={() => {
          startFreshApplication()
        }}
      >
        Start New Application
      </button>
    </div>
  )
}

export default NoDataProvided
